module.exports = __webpack_public_path__ + "media/bg/user_profile_bg-8d21db41.jpg";